//@ts-check
import React from 'react';
import FormTabs from '../controls/Tabs';
import useFormDataLayer from '../logic/useFormDataLayer';
import useFormFields from '../logic/useFormFields';
import useFormAPI from '../api';
/**
 * @param {Array<import('../logic/types').EcrionFormData>} fields
 */

var createPages = function createPages(fields) {
  return fields.map(function (field) {
    var id = field.id,
        error = field.error,
        caption = field.caption;
    return {
      id: id,
      error: error,
      caption: caption
    };
  });
};

var FormPages = function FormPages() {
  var _useFormAPI = useFormAPI(),
      state = _useFormAPI.state,
      dispatch = _useFormAPI.dispatch;

  var _useFormDataLayer = useFormDataLayer('FORM_PAGES_FIELD'),
      value = _useFormDataLayer.value;

  var pagePields = useFormFields(state.layout.pages);
  var pages = createPages(pagePields);
  if (!pages.length) return null;
  return React.createElement(FormTabs, {
    value: value,
    values: pages,
    dispatch: dispatch
  });
};

export default FormPages;